import { Button, Card, Form, Input, message, Select, Breadcrumb } from 'antd';
import React, { useEffect, useState, useMemo } from 'react';
import { connect } from 'react-redux';
import { createTeam, assignUsers, listTeamMembers } from '../../../apis/teams';
import AdminLayoutWrapper from '../AdminLayoutWrapper';
import { Link } from 'react-router-dom';
import { useParams } from 'react-router';
import ProtectAdminRoute from './custom/adminRoute';

const layout = {
  labelCol: { span: 4 },
  wrapperCol: { span: 12 },
};

const { Option } = Select;

const options = [
  {
    id: 1,
    name: 'anh.le7@tiki.vn'
  },
  {
    id: 2,
    name: 'abc@tiki.vn'
  },
  {
    id: 3,
    name: 'xyz@tiki.vn'
  }
]

const CreateNewTeam = ({ users }) => {

  const [form] = Form.useForm();

  const handleSubmit = async (values) => {
    try {
      console.log(values);
      const result = await createTeam({
        name: values.name
      });

      if (users) {
        const resultAssign = await assignUsers(result.id, {
          data: [
            {
              user_id: users.id,
              role: "team_admin"
            }
          ]
        })
      }

      message.success("Created new team successfully!")
      form.resetFields()
    } catch (error) {
      message.error(error.message);
    }
  }

  return (
    <AdminLayoutWrapper>
      <ProtectAdminRoute
      >
        <div style={{ padding: '0px 0px 16px 0px' }}>
          <Breadcrumb>
            <Breadcrumb.Item>Home</Breadcrumb.Item>
            <Breadcrumb.Item>
              <Link to={`/admin/teams/me`}>Manage Team</Link>
            </Breadcrumb.Item>
            <Breadcrumb.Item>
              Create New Team
            </Breadcrumb.Item>
          </Breadcrumb>
        </div>
        <div>Create New Team</div>
        <Card>
          <Form {...layout} form={form} onFinish={handleSubmit}>
            <Form.Item name="name" label="Team Name" rules={[
              { required: true }
            ]}
            >
              <Input />
            </Form.Item>
            <Form.Item name="description" label="Team Description" rules={[
              { required: true }
            ]}>
              <Input />
            </Form.Item>
            {/* <Form.Item name="members" label="Memebers">
            <Select
              mode="multiple"
              allowClear={false}
              style={{ minWidth: '300px' }}
              placeholder={'Please select members'}
              // defaultValue={value}
              optionLabelProp="value"
            >
              {options && options.map((option) => {
                return (
                  <Option key={option.id} value={option.id} >
                    <b>{option.id}</b> - {option.name}
                  </Option>
                )
              })}
            </Select>
          </Form.Item> */}
            <Form.Item wrapperCol={{ offset: 4, span: 12 }}>
              <Button type="primary" htmlType="submit">
                Submit
              </Button>
            </Form.Item>
          </Form>
        </Card>
      </ProtectAdminRoute>
    </AdminLayoutWrapper>
  )
}

const mapStateToProps = (state) => {
  return {
    users: state.app.user
  }
}

export default connect(mapStateToProps)(CreateNewTeam);